export default __webpack_public_path__ + "static/media/documents.a33f5124.png";